module.exports = __webpack_public_path__ + "assets/img/no-data.92d4edb9.png";